import React from 'react';
import './RequestItemCard.scss';

const RequestItemFrame = ({ title, children }: { title?: string, children: React.ReactNode }) => (
  <div className="request-item-card">
    <h1 className="request-item-card__title">{title}</h1>
    {children}
  </div>
);

RequestItemFrame.defaultProps = { title: '' };

export default RequestItemFrame;
